import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ComumService } from '../../comum/comum.service';
import { ConfirmationService } from 'primeng/primeng';
import { DashboardsService } from '../dashboards.service';
import { ParametroGrafico } from '../../comum/modelos/parametro-grafico';
import { ResultadoDashboardSingle } from '../../comum/modelos/resultado-dashboard-single';
import { ResultadoDashboardMulti } from '../../comum/modelos/resultado-dashboard-multi';
import { AuthService } from '../../auth/auth.service';

@Component({
    selector: 'app-dashboard-tile',
    templateUrl: './dashboard-tile.component.html',
    styleUrls: ['./dashboard-tile.component.css']
})
export class DashboardTileComponent implements OnInit {
    @Input() parametroGrafico: ParametroGrafico;
    @Output() parametroGraficoExcluirOutput: EventEmitter<ParametroGrafico>;
    @Output() parametroGraficoAlterarOutput: EventEmitter<ParametroGrafico>;

    public resultadoDashboardSingle: ResultadoDashboardSingle;
    public resultadoDashboardMulti: ResultadoDashboardMulti;
    showXAxis = true;
    showYAxis = true;
    refLines = [{}];
    showRefLines = false;
    showRefLabels = false;

    constructor(private _comumService: ComumService,
        private confirmationService: ConfirmationService,
        private _dashboardService: DashboardsService,
        private _authService: AuthService) {
        this.parametroGraficoExcluirOutput = new EventEmitter<ParametroGrafico>();
        this.parametroGraficoAlterarOutput = new EventEmitter<ParametroGrafico>();
        this.resultadoDashboardSingle = new ResultadoDashboardSingle();
        this.resultadoDashboardMulti = new ResultadoDashboardMulti();
    }

    ngOnInit() {
        if (this.parametroGrafico.tipoGrafico === 'line' && this.parametroGrafico.meta) {
            this.refLines = [{
                value: (this.parametroGrafico.indicador.metaIndicador * this.parametroGrafico.indicador.notaMaximaIndicador) / 100,
                name: 'Meta'
            }];
            this.showRefLines = true;
            this.showRefLabels = true;
        } else {
            this.refLines = [{}];
            this.showRefLines = false;
            this.showRefLabels = false;
        }
    }

    removerGrafico(): void {
        this.confirmationService.confirm({
            message: 'Deseja excluir este gr\u00e1fico?',
            accept: () => {
                this.parametroGraficoExcluirOutput.emit(this.parametroGrafico);
            }, reject: () => {
            }
        });
    }

    receberParametrosGrafico(param: ParametroGrafico): void {
        // this.parametroGrafico = param;
        this.parametroGraficoAlterarOutput.emit(this.parametroGrafico);
    }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/dashboards/dashboard-tile/dashboard-tile.component.ts